import CustomerLookupConfig from 'models/customer_lookup_config';
import ErrConverter from 'scripts/application/dto_converters/err_converter';
import Integrations from 'models/location/integrations';
import LookupApi from 'models/location/integrations/lookup_api';
import NavigateTo from 'actions/current_location/navigate_to';
import qconsole from 'scripts/lib/qconsole';

export default class CustomerLookupConfigurationGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onFetchError(errorDto) {
    qconsole.log(`Failed to fetch endpoints ${JSON.stringify(errorDto)}`);
    this.context.stores.lookupApiConfig.resetLoading();
  }

  onFetchSuccess(customerLookupConfig) {
    if (customerLookupConfig && customerLookupConfig.adapterType && customerLookupConfig.adapterType === 'LOOKUP_API') {
      this.context.stores.lookupApiConfig.set(CustomerLookupConfig.fromJs(customerLookupConfig));
    }

    this.context.stores.lookupApiConfig.resetLoading();
  }

  onBroadcast(customerLookupConfig) {
    if (customerLookupConfig && customerLookupConfig.adapterType && customerLookupConfig.adapterType === 'LOOKUP_API') {
      this.context.stores.lookupApiConfig.set(CustomerLookupConfig.fromJs(customerLookupConfig));
    }

    this.context.stores.lookupApiConfig.resetLoading();
  }

  onBroadcastDelete() {
    this.context.stores.lookupApiConfig.remove();
  }

  onReplaceSuccess() {
    this.context.stores.lookupApiConfig.resetPending();
    if (this.isOnLookupApiPage()) {
      this.context.executeAction(NavigateTo, Integrations.create());
    }
  }

  onReplaceError({ errors }) {
    this.context.stores.lookupApiConfig.setErrors(errors.map(ErrConverter.fromDto));
    this.context.stores.lookupApiConfig.resetPending();
  }

  isOnLookupApiPage() {
    let currentLocation = this.context.stores.currentLocation.get();
    return currentLocation instanceof LookupApi;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/lookup_api_config/customer_lookup_configuration_gateway_observer.js